import qs from 'querystring';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router';

import { SERVICE_NAME } from '~constants/app';
import { signup } from '~redux/auth/reducers/signup';
import { authUserSelector } from '~redux/auth/selectors/authUser';
import BuyerCases from '../../../widgets/BuyerCases';
import HomeBuyersCategories from '../../../widgets/HomeBuyersCategories/index.js';
import HomeFaqBuyers from '../../../widgets/HomeFaqBuyers';
import HomeHeroBuyers from '../../../widgets/HomeHeroBuyers';
import HomeServiceforBuyers from '../../../widgets/HomeServiceforBuyers';

// import './HomeCommon.scss';
import { useHeadContent } from '~view/hooks/head';
import HomeBrands from '~view/widgets/HomeBrands';
import HomeCategories from '~view/widgets/HomeCategories';

const HomePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(authUserSelector);
  const isSignup = !!qs.parse(history.location.search?.split('?')?.[1])?.signup;

  useEffect(() => {
    if (user || !isSignup) {
      return;
    }
    dispatch(signup());
  }, [isSignup, user]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useHeadContent({
    title: SERVICE_NAME,
    description: SERVICE_NAME,
    breadcrumbs: [
      {
        text: 'トップ',
      },
    ],
  });

  if (user) {
    return <Redirect to="/home" />;
  }

  return (
    <div id="home-buyers">
      {/* Home Hero Buyers */}
      <HomeHeroBuyers />
      <HomeCategories />
      <HomeBrands />

      {/* HomeServiceforBuyers */}
      <HomeServiceforBuyers />
      <BuyerCases />
      <HomeBuyersCategories />
      <HomeFaqBuyers />
    </div>
  );
};

export default HomePage;
